module.exports = __webpack_public_path__ + "img/ctrl-hadamard-stub-down-+.9545bd71.svg";